export const buildAuditHeaders = (user, extraHeaders = {}) => ({
  ...extraHeaders,
  ...(user?.id ? { 'X-User-Id': user.id } : {}),
  ...(user?.role ? { 'X-User-Role': user.role } : {}),
  ...(user?.name ? { 'X-User-Name': user.name } : {}),
});

export const auditFetch = (url, options = {}, user = null) => {
  const headers = buildAuditHeaders(user, options.headers || {});
  return fetch(url, {
    ...options,
    headers,
  });
};
